import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useUserContext } from "contexts/contextUser";
import { ParameterApi } from "./ops";

export const parameterKeys = {
  all: ["parameter"] as const,
  details: (name: string) => [...parameterKeys.all, "details", name] as const,
};

export function useParameterByName(name: string) {
  return useQuery({
    queryKey: parameterKeys.details(name),
    queryFn: ({ signal }) => {
      if (!name) throw new Error("name is required");
      return ParameterApi.getValue(name, signal);
    },
    enabled: !!name,
  });
}

export function useUpdateParameter() {
  const queryClient = useQueryClient();
  const { accessToken } = useUserContext();
  return useMutation({
    mutationFn: async ({ name, value }: { name: string; value: string }) => {
      if (!name || !accessToken) throw new Error("name and access token are required");
      return ParameterApi.putValue(accessToken, name, value);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: parameterKeys.details(variables.name),
      });
    },
  });
}
